.cq{outline:none;}